<div class="header-section">
  <div class="title-section">
    <mat-icon (click)="goback()" class="same-line">arrow_back</mat-icon>
    <h3 class="same-line">{{type | transformTitle}} Audit Details</h3>
    @for (tab of migratedData; track tab) {
      @if (tab.selected) {
        <div class=" same-line sub-title"><i class="material-icons same-line">chevron_right</i> {{tab.name | transformTitle}}</div>
      }
    }
  </div>
</div>

<div class="audit-details-section">
  <div class="list-section">
    @for (tab of migratedData; track tab) {
      <div class="list-items" [class.selected]="tab.selected" (click)="onSelectMenu(tab)">
        <mat-icon>{{tab.icon}}</mat-icon>
        {{tab.name | transformTitle}}
      </div>
    }
  </div>
  <div class="content-panel">
    @for (tab of migratedData; track tab) {
      @if (tab.selected && !tab.isArray) {
        <div class="detail-section">
          @if (tab.details?.length !== 0) {
            <div class="sub-title">{{tab.title}}</div>
          }
          <ul mat-list class="field-row list-striped" >
            @for (detail of tab.details; track detail) {
              <li>
                <span class="label">{{detail.fieldName | transformTitle}}</span>
                <span class="value">{{detail.fieldValue}}</span>
              </li>
            }
          </ul>
          @if (tab.details?.length === 0) {
            <div class="no-data-section">{{sharedDataContent.no_data_found}}</div>
          }
        </div>
      }
      @if (tab.selected && tab.isArray) {
        <div class="detail-section" >
          <table class="table table-striped">
            <thead>
              @for (detail of tab.details; track detail; let f = $first) {
                <tr class="row header">
                  @for (key of objectKeys(detail); track key) {
                    @if (f) {
                      <th class="cell header">{{key | transformTitle}}</th>
                    }
                  }
                </tr>
              }
            </thead>
            <tbody>
              @for (detail of tab.details; track detail) {
                <tr class="row">
                  @for (key of objectKeys(detail); track key) {
                    <td class="cell">{{detail[key]}}</td>
                  }
                </tr>
              }
            </tbody>
          </table>
          @if (tab.details?.length === 0) {
            <div class="no-data-section">{{sharedDataContent.no_data_found}}</div>
          }
        </div>
      }
    }
  </div>
</div>